export enum RemoteConfigKeys {
  NEWEST_VERSION = 'newest_version',
  AVAILABLE_VERSIONS = 'available_versions'
}
